import type React from "react";
import { useState } from "react";
import noop from "lodash/noop";
import { SWReactIcons } from "@similarweb/icons";
import { Dropdown } from "@similarweb/ui-components";
import { IconButton } from "@similarweb/ui-components";
import { i18nFilter } from "app/filters/i18nFilter";
import { PlainTooltip } from "@similarweb/ui-components";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import type { IAssetCreationItem } from "app/pages/digital-suite/home-page/components/CustomAssets/types";
import {
    DropdownItem,
    DropdownItemLayout,
    DropdownTitle,
} from "app/pages/digital-suite/home-page/components/CustomAssets/AssetCreationButton/styledComponents";
import { allTrackers } from "app/services/track/track";

interface IAssetCreationButtonProps {
    items: IAssetCreationItem[];
}

export const AssetCreationButton: React.FC<IAssetCreationButtonProps> = ({ items }) => {
    const i18n = i18nFilter();
    const [isDropdownActive, setDropdownActive] = useState<boolean>(false);

    return (
        <Dropdown
            activeId={""}
            selectedId={""}
            // @ts-expect-error Wrong type
            searchFilter={noop}
            searchTerm={""}
            width={"320px"}
            onClick={({ onClick }) => onClick()}
            dropdownPopupPlacement={"bottom-right"}
            onToggle={() => {
                if (!isDropdownActive) {
                    allTrackers.dispatchTrackEvent("Button", "click", "My Assets/create item");
                }
                setDropdownActive((prev) => !prev);
            }}
        >
            <IconButton
                type={"outlined"}
                iconName={"plus"}
                placement={"left"}
                iconSize={"9px"}
                isActive={isDropdownActive}
            >
                <I18n>digitalmarketing.homepage.custom_assets.button</I18n>
            </IconButton>
            <DropdownTitle>
                <I18n>digitalmarketing.homepage.custom_assets.button.dropdown.title</I18n>
            </DropdownTitle>
            {...items.map(({ iconName, onClick, text, tooltipContent }, index) => (
                <DropdownItem
                    key={index}
                    iconName={iconName}
                    iconSize={"xs"}
                    onClick={onClick}
                >
                    <DropdownItemLayout>
                        <I18n>{text}</I18n>
                        <PlainTooltip
                            placement={"right"}
                            closeDelay={100}
                            allowHover
                            tooltipContent={tooltipContent}
                        >
                            <div>
                                <SWReactIcons
                                    iconName={"info"}
                                    size={"xs"}
                                />
                            </div>
                        </PlainTooltip>
                    </DropdownItemLayout>
                </DropdownItem>
            ))}
        </Dropdown>
    );
};
